import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { PressReleaseService } from '../../../_services/preleases.service'
@Component({
  selector: 'app-brochures',
  templateUrl: './brochures.component.html',
  styleUrls: ['./brochures.component.scss']
})
export class BrochuresComponent implements OnInit {
  country: string;
  language: string;
  brochures: any;
  constructor(
    private pressReleaseService: PressReleaseService,
    private route: ActivatedRoute,

  ) { }

  getBrochures(country: string, language: string){
    this.pressReleaseService.getBrochure(country,language)
    .subscribe(
      resultArray =>{
        this.brochures= resultArray;
      },
      error => console.log('Error::'+error)
    )
  }


  ngOnInit() {
    this.route.params
    .subscribe(
      (params: Params) => {
        this.country = params['country'];
        this.language = params['language'];
        this.getBrochures(this.country, this.language);

      }
    )
  }

}
